<template lang="pug">
    .wheel-slide(:class="{active: active}", @click="onClick")
        .image(:style="{backgroundImage: 'url(\"' + data.url + '\")'}",
          ga-category="slider",
          ga-label="wheelsSlide")
</template>
<script>
export default {
  name: 'WheelSlide',
  props: ['data', 'active'],
  data () {
    return {}
  },

  mounted() {
  },

  methods: {
    onClick() {
      this.$emit('click', this.data)
    }
  }
}
</script>